<template>
  <el-dialog :title="title"
             :close-on-click-modal="false"
             width="650px"
             @closed="close"
             :visible.sync="visible">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             size="medium"
             label-width="140px"
             @submit.native.prevent="onSubmit()">
      <div class="re-el-form__flex">
        <div class="medium">
          <el-form-item label="公司名称"
                        prop="name"
                        clearable>
            <el-input v-model="form.name"
                      :disabled="!!form.id"
                      placeholder="请输入公司名称" />
          </el-form-item>
          <el-form-item label="金蝶编码"
                        prop="kingdee_number">
            <el-input v-model="form.kingdee_number"
                      placeholder="请输入金蝶编码" />
          </el-form-item>
          <el-form-item key="finance_ids"
                        prop="finance_ids">
            <template slot="label">
              <span>财务负责人</span>
              <el-tooltip
                effect="dark"
                placement="top"
                content="仅支持搜索活跃状态下的财务管理员。若搜索不到对应负责人，请确认该负责人账号是否为财务管理员，状态是否为活跃状态">
                <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer;"></i>
              </el-tooltip>
            </template>
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入管理员用户名搜索"
                           v-model="form.finance_ids"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [5], status: 1}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="close()"> 取消 </el-button>
        <el-button type="primary"
                   @click="onSubmit()"> 提交
        </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RemoteSelect from '@core/components/RemoteSelect'
import { companyFormRules as formRules } from '../finance-config.rules.js'

export default {
  data () {
    return {
      visible: false,
      loading: true,
      formRules,
      form: {
        id: null,
        name: '',
        finance_ids: [],
        kingdee_number: ''
      }
    }
  },
  computed: {
    title () {
      return this.form.id ? '修改公司' : '创建公司'
    }
  },
  components: {
    RemoteSelect
  },
  methods: {
    ...request.map(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.id ? this.update(this.form) : this.create(this.form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (data) {
      request.common('createOurCompany', data).then(({data}) => {
        this.$message.success(this.title + '成功')
        this.$emit('submitted')
        this.close()
      })
    },
    update (data) {
      request.common('updateOurCompany', data).then(({data}) => {
        this.$message.success(this.title + '成功')
        this.$emit('submitted')
        this.close()
      })
    },
    show (id) {
      Object.assign(this.$data, this.$options.data.call(this))
      this.visible = true

      if (id) {
        this.form.id = id
        request.common('getOurCompanyDetail', {id}).then(({data}) => {
          const financeIds = data.finance_ids
          delete data.finance_ids
          filter.setLoop(this.form, data)
          this.$nextTick(() => {
            this.$set(this.form, 'finance_ids', Array.isArray(financeIds) ? [...financeIds] : [])
          })
        })
      }
    },
    close () {
      this.visible = false
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate && this.$refs['form'].clearValidate()
        this.$refs['form'].resetFields && this.$refs['form'].resetFields()
      }
      Object.assign(this.$data, this.$options.data.call(this))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/finance-config/components/CompanyFormDialog.vue